// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"839":"f9ceb668","855":"58810410"}[chunkId] + ".chunk.js";
};